import type { StatusOrdemServico } from '@/types/ordemServico';

/**
 * Status inicial de uma OS acabada de criar, espelhando o invariante imposto na BD
 * pelo trigger `trg_os_aceitar_ao_atribuir_prestador` (BEFORE INSERT OR UPDATE):
 * uma OS com prestador atribuído nunca fica 'pendente'.
 *
 * - COM prestador → 'aceita'. (Sem isto a OS nascia 'pendente'+atribuída e ficava
 *   invisível ao prestador: fora de "Disponíveis", que exige `prestador_id IS NULL`,
 *   e fora de "Aceitas", que exige `status='aceita'`.)
 * - SEM prestador → 'pendente' (fila de disponíveis).
 *
 * Defesa em profundidade: a BD é a fonte de verdade (o trigger normaliza qualquer
 * caminho de INSERT/UPDATE), mas a app define o status explicitamente para não
 * depender apenas do default da coluna + trigger.
 */
export function statusInicialOS(
  prestadorId: string | null | undefined,
): StatusOrdemServico {
  return prestadorId ? 'aceita' : 'pendente';
}
